import Repository from './Repository'

const resource = '';

export default {
	getArticles (number) {
		if (!number) {
			number = 45;
		}
		return Repository.get('/articles?n=' + number);
	},
}